@use '~/theme/theme' as *;

.root {
  --radius: #{spacing(1)};

  border-color: color(grey-300);
  border-radius: var(--radius);
  border-width: var(--stroke);
  border-style: solid;

  &.radiusMedium {
    --radius: #{spacing(2)};
  }

  &.radiusLarge {
    --radius: #{spacing(3)};
  }

  &.radiusFull {
    --radius: #{spacing(10)};
  }

  &.strokeNone {
    --stroke: 0px;
  }

  &.strokeSmall {
    --stroke: 1px;
  }

  &.strokeMedium {
    --stroke: 2px;
  }

  &.strokeLarge {
    --stroke: 4px;
  }

  &.shadowSmall {
    @include shadow(sm);
  }

  &.shadowMedium {
    @include shadow(md);
  }

  &.shadowLarge {
    @include shadow(lg);
  }
}
